import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Country, State } from "country-state-city";
import styles from "./addBilling.module.css";
import { useDispatch, useSelector } from "react-redux";
import { addCBillingAddressThunk, addCShippingAddressThunk, upadteBillingAddressThunk, upadteCShippingAddressThunk } from "../../../../Website/redux/customerSlice";

const AddBilling = ({ onClose, heading,from,parent }) => {
  const [statesList, setStatesList] = useState([]);

  const { alter } = useSelector((state) => state.customer)

  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues: {
      factoryUnits: alter.data?.factoryUnits || "",
      country: alter.data?.country || "",
      state:alter.data?.state || "",
      streetAddress: alter.data?.streetAddress ||"",
      zipCode:  alter.data?.zipCode || "",
    },
    validationSchema: Yup.object({
      factoryUnits: Yup.string().required("Factory Unit is required"),
      country: Yup.string().required("Country is required"),
      state: Yup.string().required("State is required"),
      streetAddress: Yup.string().required("Street Address is required"),
      zipCode: Yup.string()
        .matches(/^\d{5,6}$/, "Invalid Zip Code")
        .required("Zip Code is required"),
    }),
    onSubmit: async (values) => {
      const data = {
        id:alter?.data?._id,
        values
      }

      const billingapi = from == 'cba' ? addCBillingAddressThunk(values) : upadteBillingAddressThunk(data)
      const shippingapi = from == 'csa' ? addCShippingAddressThunk(values) : upadteCShippingAddressThunk(data)
      const api = parent == 'billing' ? billingapi : shippingapi

      const status = await dispatch(api)
      if (status?.payload === 200) {
        onClose()
      }
    },
  });

  console.log(alter?.data?._id);
  
  useEffect(() => {
    if (alter?.data?.country) {
      const selectedCountry = Country.getAllCountries().find(
        (country) => country.name === alter.data.country
      );
      if (selectedCountry) {
        const stateList = State.getStatesOfCountry(selectedCountry.isoCode);
        setStatesList(stateList);
  
        if (alter.data.state) {
          const matchedState = stateList.find(
            (state) => state.name === alter.data.state
          );
          if (matchedState) {
            formik.setFieldValue("state", matchedState.name);
          }
        }
      }
    }
  }, [alter.data, formik.setFieldValue]);
  
  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    formik.setFieldValue("country", selectedCountry);
  
    const countryData = Country.getAllCountries().find(
      (country) => country.name === selectedCountry
    );
  
    if (countryData) {
      const states = State.getStatesOfCountry(countryData.isoCode);
      setStatesList(states);
      formik.setFieldValue("state", ""); 
    } else {
      setStatesList([]);
      formik.setFieldValue("state", ""); 
    }
  };
  
  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <button className={styles.popupcloseButton} onClick={onClose}>
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 7.5875 7.5875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375ZM15 3.4375C8.625 3.4375 3.4375 8.625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375Z"
              fill="#A4A4A4"
            />
            <path
              d="M11.4627 19.4742C11.2252 19.4742 10.9877 19.3867 10.8002 19.1992C10.4377 18.8367 10.4377 18.2367 10.8002 17.8742L17.8752 10.7992C18.2377 10.4367 18.8377 10.4367 19.2002 10.7992C19.5627 11.1617 19.5627 11.7617 19.2002 12.1242L12.1252 19.1992C11.9502 19.3867 11.7002 19.4742 11.4627 19.4742Z"
              fill="#A4A4A4"
            />
            <path
              d="M18.5377 19.4742C18.3002 19.4742 18.0627 19.3867 17.8752 19.1992L10.8002 12.1242C10.4377 11.7617 10.4377 11.1617 10.8002 10.7992C11.1627 10.4367 11.7627 10.4367 12.1252 10.7992L19.2002 17.8742C19.5627 18.2367 19.5627 18.8367 19.2002 19.1992C19.0127 19.3867 18.7752 19.4742 18.5377 19.4742Z"
              fill="#A4A4A4"
            />
          </svg>
        </button>
        <div className={styles.popuptitle}>{heading}</div>

        <form className={styles.qrForm} onSubmit={formik.handleSubmit}>
          <div className={styles.hrLine}></div>
          <div className={styles.qrForminputMain}>
            <div className={styles.loginFormRow1}>
              <div className={styles.loginInputGroup}>
                <label>Factory Units</label>
                <select
                  name="factoryUnits"
                  className={styles.selectField}
                  value={formik.values.factoryUnits}
                  onChange={formik.handleChange}
                >
                  <option value="">Select</option>
                  <option value="Unit 1">Unit 1</option>
                  <option value="Unit 2">Unit 2</option>
                </select>
                {formik.touched.factoryUnits && formik.errors.factoryUnits && (
                  <div className={styles.error}>{formik.errors.factoryUnits}</div>
                )}
              </div>
              <div className={styles.loginInputGroup2}>
                <label>Street Address</label>
                <input
                  type="text"
                  name="streetAddress"
                  placeholder="Enter street address"
                  value={formik.values.streetAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{ fontSize: 14, color: '#666666' }}
                />
                {formik.touched.streetAddress && formik.errors.streetAddress && (
                  <div className={styles.error}>{formik.errors.streetAddress}</div>
                )}
              </div>
            </div>
            <div className={styles.loginFormRow2}>
              <div className={styles.loginInputGroup}>
                <label>Country / Region</label>
                <select
                  name="country"
                  className={styles.selectField}
                  value={formik.values.country}
                  onChange={handleCountryChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select</option>
                  {Country.getAllCountries().map((country) => (
                    <option key={country.isoCode} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
                {formik.touched.country && formik.errors.country && (
                  <div className={styles.error}>{formik.errors.country}</div>
                )}
              </div>

              <div className={styles.loginInputGroup}>
                <label>State</label>
                <select
                  name="state"
                  className={styles.selectField}
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={statesList.length === 0}
                >
                  <option value="">Select</option>
                  {statesList.map((state) => (
                    <option key={state.isoCode} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
                {formik.touched.state && formik.errors.state && (
                  <div className={styles.error}>{formik.errors.state}</div>
                )}
              </div>

              <div className={styles.loginInputGroup}>
                <label>Zip Code</label>
                <input
                  type="text"
                  name="zipCode"
                  placeholder="Enter Zip Code"
                  value={formik.values.zipCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{ fontSize: 14, color: '#666666' }}
                />
                {formik.touched.zipCode && formik.errors.zipCode && (
                  <div className={styles.error}>{formik.errors.zipCode}</div>
                )}
              </div>
            </div>
            <button type="submit" className={styles.savechanges} disabled={alter.loading}>
              {alter.loading ? 'Please wait' : 'Save Address'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBilling;
